export type PlaylistDisplayHubType = PlaylistDisplayHub;
export type PlaylistDisplayHubsType = PlaylistDisplayHub[];

export type PlaylistDisplayHubResponseType = PlaylistDisplayHubType;
export type PlaylistDisplayHubsResponseType = PlaylistDisplayHubsType;

export type PlaylistDisplayHubStateType = {
  playlistDisplayHubs: PlaylistDisplayHubsType | null;
  selectedPlaylistDisplayHub: PlaylistDisplayHubType | null;
  loading: boolean;
  error: string | null;
};

export const PLAYLIST_DISPLAY_HUB = 'playlistDisplayHub';
export type PLAYLIST_DISPLAY_HUB = typeof PLAYLIST_DISPLAY_HUB;

export const REQUEST_CREATE_PLAYLIST_DISPLAY_HUB = `${PLAYLIST_DISPLAY_HUB}/requestCreatePlaylistDisplayHub`;
export type REQUEST_CREATE_PLAYLIST_DISPLAY_HUB = typeof REQUEST_CREATE_PLAYLIST_DISPLAY_HUB;

export const REQUEST_DELETE_PLAYLIST_DISPLAY_HUB = `${PLAYLIST_DISPLAY_HUB}/requestDeletePlaylistDisplayHub`;
export type REQUEST_DELETE_PLAYLIST_DISPLAY_HUB = typeof REQUEST_DELETE_PLAYLIST_DISPLAY_HUB;

export const REQUEST_DUPLICATE_PLAYLIST_DISPLAY_HUB = `${PLAYLIST_DISPLAY_HUB}/requestDuplicatePlaylistDisplayHub`;
export type REQUEST_DUPLICATE_PLAYLIST_DISPLAY_HUB = typeof REQUEST_DUPLICATE_PLAYLIST_DISPLAY_HUB;

export const REQUEST_UPDATE_PLAYLIST_DISPLAY_HUB = `${PLAYLIST_DISPLAY_HUB}/requestUpdatePlaylistDisplayHub`;
export type REQUEST_UPDATE_PLAYLIST_DISPLAY_HUB = typeof REQUEST_UPDATE_PLAYLIST_DISPLAY_HUB;

export const REQUEST_UPDATE_PLAYLIST_DISPLAY_HUB_PREVIEW = `${PLAYLIST_DISPLAY_HUB}/requestUpdatePlaylistDisplayHubPreview`;
export type REQUEST_UPDATE_PLAYLIST_DISPLAY_HUB_PREVIEW =
  typeof REQUEST_UPDATE_PLAYLIST_DISPLAY_HUB_PREVIEW;

export const REQUEST_REORDER_PLAYLIST_DISPLAY_HUB = `${PLAYLIST_DISPLAY_HUB}/requestReorderPlaylistDisplayHub`;
export type REQUEST_REORDER_PLAYLIST_DISPLAY_HUB = typeof REQUEST_REORDER_PLAYLIST_DISPLAY_HUB;

export const REQUEST_GET_ALL_PLAYLIST_DISPLAY_HUBS = `${PLAYLIST_DISPLAY_HUB}/requestGetAllPlaylistDisplayHubs`;
export type REQUEST_GET_ALL_PLAYLIST_DISPLAY_HUBS = typeof REQUEST_GET_ALL_PLAYLIST_DISPLAY_HUBS;

export const REQUEST_SET_SELECTED_PLAYLIST_DISPLAY_HUB = `${PLAYLIST_DISPLAY_HUB}/requestSetSelectedPlaylistDisplayHub`;
export type REQUEST_SET_SELECTED_PLAYLIST_DISPLAY_HUB =
  typeof REQUEST_SET_SELECTED_PLAYLIST_DISPLAY_HUB;
